<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Sales Invioce</h4>
                <p class="text-subtitle">Customer Invoice Display</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn 
                    block
                    color="primary"
                    :loading="loading.simulate"
                    @click="simulate">
                    <v-icon left>mdi-form-select</v-icon>
                    Simulate
                </v-btn>
            </v-col>
        </v-row>
        <div class="text-center" v-if="loading.data">
            <v-progress-circular
                indeterminate>
            </v-progress-circular>
        </div>
        <div>
            <v-alert type="info" dense text v-if="loading.simulate">
                <span v-html="aicaSimulatingAlert"></span>
            </v-alert>
            <v-subheader>{{ $t('title_info') }}</v-subheader>
            <v-simple-table dense>
                <tbody>
                    <tr>
                        <th>{{ $t('date') }}</th>
                        <td>{{ invoice?invoice.date: null }}</td>
                            <th>{{ $t('document_date') }}</th>
                        <td>{{  invoice?invoice.date: null }}</td>
                        <th>{{ $t('code') }}</th>
                        <td>{{  invoice?invoice.code: null }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('customer') }}</th>
                        <td>{{  invoice?invoice.customer:null }}</td>
                        <th>{{ $t('sites_customer') }}</th>
                        <td>{{  invoice?invoice.site:null }}</td>
                        <th>{{ $t('state') }}</th>
                        <td>
                            <!-- <v-badge dot :color="getColor(invoice.state)" inline left></v-badge>{{ invoice.state }} -->
                            <p-status v-if="invoice" :state="invoice.state"></p-status>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <v-subheader>{{ $t('invoice_line') }}</v-subheader>
            <v-simple-table dense>
                <thead>
                    <tr>
                        <th>{{ $t('concrete') }}</th>
                        <th>{{ $t('cast_type') }}</th>
                        <th>{{ $t('quantity') }}</th>
                        <th>{{ $t("unit_measure") }}</th>
                        <th>{{ $t('price') }}</th>
                        <th>{{ $t("sub_total") }}</th>
                        <th>{{ $t("discount") }}</th>
                        <th>{{ $t("tax") }}</th>
                        <th>{{ $t('total') }}</th>
                        <th>{{ $t('sales_order_code') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr  v-for="(invoiceItem, indexInvoice) in invoice? invoice.invoice_item_lines:{}" :key="indexInvoice">
                        <td>{{ invoiceItem.item }}</td>
                        <td>{{ invoiceItem.cast_type }}</td>
                        <td>{{ invoiceItem.quantity }}</td>
                        <td>{{ invoiceItem.measure_unit }}</td>
                        <td>{{ formatPrice(invoiceItem.price) }}</td>
                        <td>{{ formatPrice(invoiceItem.subtotal) }}</td>
                        <td>{{ formatPrice(invoiceItem.discount) }}</td>
                        <td>{{ formatPrice(invoiceItem.tax) }}</td>
                        <td>{{ formatPrice(invoiceItem.total) }}</td>
                        <td>{{ invoiceItem.sales_order_code }}</td>
                    </tr>
                    <tr>
                        <th colspan="7"></th>
                        <th>{{ $t('sub_total') }}</th>
                        <td colspan="2"><b>{{ formatPrice(invoice? invoice.subtotal: null) }}</b></td>
                    </tr>
                    <tr>
                        <th colspan="7"></th>
                        <th>{{ $t('discount') }}</th>
                        <td colspan="2"><b>{{ formatPrice(invoice?invoice.discount: null) }}</b></td>
                    </tr>
                    <tr>
                        <th colspan="7"></th>
                        <th>{{ $t('tax') }}</th>
                        <td colspan="2"><b>{{ formatPrice(invoice?invoice.tax: null) }}</b></td>
                    </tr>
                    <tr>
                        <th colspan="7"></th>
                        <th>{{ $t('total') }}</th>
                        <td colspan="2"><b>{{ formatPrice(invoice?invoice.total: null) }}</b></td>
                    </tr>
                </tbody>
            </v-simple-table>
            <br>
            <v-simple-table dense>
                <thead>
                    <tr>
                        <th>{{ $t('created_by') }}</th>
                        <th>{{ $t('created_at') }}</th>
                        <th>{{ $t('updated_by') }}</th>
                        <th>{{ $t('updated_at') }}</th>
                        <th>{{ $t('posted_by') }}</th>
                        <th>{{ $t('posted_at') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ invoice? invoice.created_by: null }}</td>
                        <td>{{ moment(invoice? invoice.created_at: null).format("YYYY-MM-DD HH:MM:SS") }}</td>
                        <td>{{ invoice? invoice.updated_by: null }}</td>
                        <td>{{ moment(invoice? invoice.updated_at: null).format("YYYY-MM-DD HH:MM:SS") }}</td>
                        <td>{{ invoice? invoice.posted_by: null }}</td>
                        <td>{{ invoice? invoice.posted_at: null }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>
        <simulate-entries
            v-if="simulateEntryShown"
            v-model="simulateEntryShown"
            :entry="simulatedEntry"
            :is-posted="isPosted"
            :can-post="canPost"
            @post="invoicePost"
            >
        </simulate-entries>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <decision-dialog
            ref="decisionDialog"
            @submit="onSubmitDecision">
        </decision-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import {formatMoney} from 'accounting';
import moment from 'moment';


import { getDpk } from '../../services/sales';
import { postInvoiceToLedger, simulateInvoice } from '../../services/sales/invoice';
import { aicaSimulatingAlert } from '../../assets/text/alerts';

import RetryDialog from '@/components/common/RetryDialog';
import SimulateEntries from '../../components/accounting/SimulateEntries.vue';
import getColor from '@/utils/getColor';
import PStatus from '../../components/common/PStatus.vue';
import DecisionDialog from '@/components/common/DecisionDialog'

export default {
    name: "CustomerInvoiceDisplayView",
    components: {
        RetryDialog,
        SimulateEntries,
        PStatus,
        DecisionDialog
    },
    data() {
        return {
            dpk: null,
            display: false,
            openParams: null,
            loading: {
                data: false,
                simulate: false
            },
            simulateEntryShown: false,
            aicaSimulatingAlert,
            simulatedEntry: {}
        }
    },
    computed: {
        ...mapState('sales/invoice', ["invoice"]),
        isPosted() {
            return this.invoice.is_posted;
        },
        canPost() {
            return this.invoice.meta.can_post;
        }
    },
    methods: {
        formatPrice(amount) {
            return formatMoney(amount, "SDG ", 2);
        },
        getColor,
        moment,
        ...mapActions("sales/invoice", ["fetchInvoice"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.openDatafetch();
        },
        async openDatafetch() {
            try {
                await this.fetchInvoice(this.openParams.id);
                getDpk().then(response => this.dpk = response.data.key);
                this.loading.data = false;  
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"openDataFetch",message});
            }
        },
        simulate() {
            this.loading.simulate = true;
            simulateInvoice({invoiceId: this.invoice.id})
                .then(response => {
                    this.simulatedEntry = response.data;
                    this.simulateEntryShown = true;
                })
                .finally(() => {
                    this.loading.simulate = false;
                });
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close()
            }
        },
        openDecisionDialog() {
            let params = { title: this.$t('confirm_title') , content: this.$t('are_you_sure_posted'), target: 'post'};
            this.$refs.decisionDialog.open(params);
        },
        onSubmitDecision(params) {
            if(params.target == 'post') this.invoicePost();
        },
        async invoicePost() {
            this.loading.data = true;
            postInvoiceToLedger({invoiceId: this.openParams.id, dpk: this.dpk})
                .then(response => {
                    this.setSnackBars({ message: this.$t('msg_post') });
                    this.openDatafetch();
                    this.$emit("updated:invoice", response.data.record);
                })
                .finally(() => {
                    this.loading.data = false;
                })
        },
        close() {
            this.display = false;
        }
        
    },
    mounted() {
        this.open({id: this.$route.params.id})
    }
}
</script>